import request from './request'

export function sendVerifyCode(userMobile, isJudgeRegistered) {
  return request({
    url: '/api/sendVerifyCode',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: `userMobile=${userMobile}&isJudgeRegistered=${isJudgeRegistered}`
  })
}
export function isVerifyCodeOK(mobileNo, verifyCode) {
  return request({
    url: '/api/isVerifyCodeOK ',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: `mobileNo=${mobileNo}&verifyCode=${verifyCode}`
  })
}
export function updatePasswordInForgetProcess(model) {
  return request({
    url: '/user/updatePasswordInForgetProcess',
    method: 'post',
    data: model
  })
}
export function saveData(model) {
  return request({
    baseURL: 'http://register.icoldchain.cn:7001/',
    url: '/saveData',
    method: 'post',
    data: model
  })
}
